import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// $FlowFixMe
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchAssets, setSearchInput, setSize, toggleShowLegend } from 'app/store/reducers/library';
import { assetIcons } from 'app/components/Icons/assetsIcons';
import getProjectIdFromURL from 'app/core/utils/getProjectIdFromURL';
import { router } from 'app/containers/Assets/AssetDetail/router';
import { Checkbox, FormControlLabel, Slider as SliderBase, styled, Typography } from '@mui/material';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import classes from './Library.module.scss';
import Loader from 'app/components/Loader/Loader.jsx';
import LibraryCard from 'app/components/Card/LibraryCard';
import { Autocomplete } from '@mui/material';
import LoaderSmall from 'app/components/LoaderSmall/LoaderSmall.jsx';
const Slider = styled((props) => _jsx(SliderBase, Object.assign({}, props)))(({ theme }) => ({
    '& .MuiSlider-track': {
        height: 2,
    },
    '& .MuiSlider-rail': {
        height: 2,
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 12,
        width: 12,
        boxShadow: 'initial',
    },
}));
const Library = () => {
    var _a, _b;
    const dispatch = useDispatch();
    const projectId = getProjectIdFromURL();
    const { data, showLegend, searchInput, size, apiLoading, message } = useSelector((state) => state.library);
    const libraryData = localStorage.getItem('library');
    const libraryHistory = ((_b = (_a = JSON.parse(libraryData !== null && libraryData !== void 0 ? libraryData : '[]')) === null || _a === void 0 ? void 0 : _a[projectId]) === null || _b === void 0 ? void 0 : _b.history) || [];
    useEffect(() => {
        return () => {
            dispatch(setSearchInput(''));
        };
    }, []);
    const handleSetSearchInput = (val) => {
        dispatch(setSearchInput(val));
    };
    const handleToggleShowLegend = () => dispatch(toggleShowLegend());
    const handleSetImageSize = (val) => dispatch(setSize(Number(val)));
    const marks = [
        {
            value: 0,
            label: 'S',
        },
        {
            value: 1,
            label: 'M',
        },
        {
            value: 2,
            label: 'L',
        },
        {
            value: 3,
            label: 'XL',
        },
    ];
    const cardContent = (item) => (_jsxs("div", { className: "row noWrap alignCenter", children: [item.assetType ? (_jsx(FontIcon, { icon: assetIcons(item.assetType), className: `fontSize${size === 6 ? 18 : 14} paddingRight${size === 6 ? 7 : 5} grey alignCenter` })) : null, _jsx("span", { style: { marginBottom: '5px', fontSize: size === 6 ? 18 : 14 }, className: classes.label, children: item.name }), item.highlight.doc.map((str, index) => {
                const splitedStr = str.split('\n');
                const result = splitedStr.filter((s) => s.includes('class="highlight"'));
                return (_jsx("div", { className: classes.highlightString, children: result.map((res, i) => {
                        return (_jsx("div", { style: { whiteSpace: 'pre-wrap' }, className: "fullWidth marginTop5", dangerouslySetInnerHTML: { __html: res || '' } }, i));
                    }) }, String(index)));
            })] }));
    return (_jsxs(_Fragment, { children: [apiLoading ? (_jsx("div", { className: classes.overlay_3, children: _jsx(Loader, { className: classes.spinner }) })) : null, _jsxs("div", { className: "fullHeight overflowYAuto padding10 relative marginBottom20", children: [_jsxs("div", { className: "flex spaceBetween marginBottom30", children: [_jsx(Autocomplete, { className: classes.autocomplete, sx: { width: '1000px', outline: 'none' }, value: searchInput, options: libraryHistory === null || libraryHistory === void 0 ? void 0 : libraryHistory.map((el) => ({ label: el, value: el })), renderInput: (params) => (_jsxs("div", { ref: params.InputProps.ref, className: classes.searchInputContainer, children: [_jsx("input", Object.assign({ placeholder: "Search asset", type: "text", onKeyDown: (e) => {
                                                if (e.key === 'Enter') {
                                                    if (searchInput && e.target.value === searchInput)
                                                        dispatch(searchAssets({ query: searchInput, projectId }));
                                                }
                                            } }, params.inputProps)), _jsx("div", { className: classes.searchBtn, onClick: () => dispatch(searchAssets({ query: searchInput, projectId })), "data-testid": "library-searchBtn", children: apiLoading ? _jsx(LoaderSmall, {}) : _jsx(FontIcon, { icon: "fas-search" }) })] })), onInputChange: (e, val) => handleSetSearchInput(val), onChange: (e, val) => {
                                    if (val) {
                                        handleSetSearchInput(val.value);
                                        dispatch(searchAssets({ query: val.value.trim(), projectId }));
                                    }
                                } }), _jsxs("div", { className: "flex", children: [_jsx(FormControlLabel, { className: "marginRight50", label: _jsx(Typography, { className: "fontSize14", children: "Show legend" }), control: _jsx(Checkbox, { "data-testid": "library-legend-checkbox", size: "small", checked: showLegend, onChange: handleToggleShowLegend, name: "legend", color: "primary", disabled: !(data === null || data === void 0 ? void 0 : data.length) }) }), _jsxs("div", { className: "flex column marginRight50", children: [_jsx("p", { className: "fontSize14", children: "Size" }), _jsx(Slider, { "data-testid": "library-size-slider", sx: { width: 300 }, disabled: !(data === null || data === void 0 ? void 0 : data.length), value: size === 6 ? 3 : size - 2, onChange: (e, val) => handleSetImageSize(val), min: 0, max: 3, "aria-labelledby": "discrete-slider-restrict", step: null, marks: marks })] })] })] }), _jsx("div", { style: {
                            display: 'grid',
                            gridTemplateColumns: `repeat(${9 - size}, minmax(0, 1fr))`,
                            columnGap: '20px',
                            rowGap: '20px',
                        }, children: !data.length ? (_jsxs("div", { className: classes.noResults, children: [_jsx("span", { children: message }), _jsx(FontIcon, { icon: "fas-search" })] })) : (data.map((item) => {
                            var _a, _b, _c;
                            return (_jsx(LibraryCard, { title: item.name, cardContent: cardContent(item), showLegend: showLegend, height: size * 100, image: (_b = (_a = item.thumbnailInst) === null || _a === void 0 ? void 0 : _a.thumbnail) !== null && _b !== void 0 ? _b : (_c = item.thumbnailInst) === null || _c === void 0 ? void 0 : _c.url, onClick: () => router.goTo('index', { assetId: item.id }, { rightPanel: true }), size: size }, item.id));
                        })) })] })] }));
};
export default Library;
